module.exports = __webpack_public_path__ + "img/ring_r_o_1_null.6642cfb9.png";